import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";
import {
  DisplayContainer,
  StyledArrowIcon,
} from "scmp-app/components/search/search-result-panel/components/dropdown-menu/styles";
import { Container as SectionSearchResultListContainer } from "scmp-app/components/search/search-result-panel/search-result-list/section-search-result-list/styles";
import { Container as TopicSearchResultListContainer } from "scmp-app/components/search/search-result-panel/search-result-list/topic-search-result-list/styles";
import { Container as VideoSectionSearchResultListContainer } from "scmp-app/components/search/search-result-panel/search-result-list/video-section-search-result-list/styles";

import { SearchResultListSortingMenu } from "./sorting-menu";

export const Container = styled.div`
  ${SectionSearchResultListContainer} +${VideoSectionSearchResultListContainer} {
    border-block-start: none;
  }
  ${VideoSectionSearchResultListContainer} +${TopicSearchResultListContainer} {
    border-block-start: none;
  }
`;

export const StyledLoading = styled(Loading)`
  margin-block: 40px;
`;

export const StyledSearchResultListSortingMenu = styled(SearchResultListSortingMenu)`
  flex-basis: max-content;
  flex-shrink: 0;
`;

export const HeaderContainer = styled.div`
  ${StyledArrowIcon} {
    margin-inline-start: 6px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  gap: 28px;
  align-items: center;

  ${theme.breakpoints.only("mobile")} {
    gap: 16px;
  }
`;

export const AdvancedFilterOptionsContainer = styled.div`
  display: flex;
  gap: 28px;
  align-items: flex-start;

  margin-block-end: 40px;

  ${DisplayContainer} {
    inline-size: max-content;

    font-size: 14px;
    line-height: normal;
  }

  ${theme.breakpoints.between("mobile", "desktop")} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ResultAndSortingContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;

  margin-block-end: 22px;
  ${theme.breakpoints.between("mobile", "desktop")} {
    align-items: center;
  }
`;

export const TotalResultText = styled.div`
  display: flex;

  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  white-space: break-spaces;
  ${theme.breakpoints.between("mobile", "desktop")} {
    display: block;
  }
`;

export const TotalCount = styled.span`
  color: #666666;
  font-weight: 700;
`;

export const ResultText = styled.div``;

export const NoResultsContainer = styled.div``;

export const TaxonomySearchResultListContainer = styled.div`
  & > div {
    border-block-end: 1px solid rgba(0, 0, 0, 0.2);

    &:first-of-type {
      border-block-start: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
`;

export const NoResultsHeader = styled.p`
  margin-block: 0 16px;
  margin-inline: 0;

  color: #000000;
  font-weight: 900;
  font-size: 24px;
  font-family: ${fontRoboto};
  line-height: 28px;

  ${theme.breakpoints.up("desktop")} {
    margin-block: 0 12px;
    margin-inline: 0;

    font-weight: 900;
    font-size: 28px;
    font-family: ${fontRoboto};
    line-height: 33px;
  }
`;

export const NoResultsContent = styled.p`
  color: #000000;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
`;

export const NoArticleResultsContent = styled.p`
  margin-block: 20px;

  color: #666666;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%; /* 18.2px */
`;
